module.exports = __webpack_public_path__ + "static/CarpathianSeagul-0347b860039422c11f35ea7f1802ecab.png";